import axios from 'axios';

const api = {
  async fetchTwilioAccessToken() {
    const response = await axios.get(`/twilio/generate_access_token`);
    return response.data;
  },

  async fetchTwilioAccessTokenPublic(clientToken) {
    const response = await axios.get(
      `/twilio/generate_access_token_public/${clientToken}`
    );
    return response.data;
  },
};

export default api;
